/*
 * File: UpdateCourseEnrollmentCriteria.ts
 * Author: Austin Robinson
 * Date Created: 10/8/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createMutation } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type UpdateCourseEnrollmentCriteriaParams = {
  courseId: string;
  policy: {
    min_age_to_register: PostGreSQLInterval | null;
    max_age_to_register: PostGreSQLInterval | null;
    min_age_at_first_period: PostGreSQLInterval | null;
    max_age_at_first_period: PostGreSQLInterval | null;
    require_permit_to_register: boolean;
  };
};

export type UpdateCourseEnrollmentCriteriaResult = boolean;

async function updateCourseEnrollmentCriteria(
  params: UpdateCourseEnrollmentCriteriaParams,
): Promise<UpdateCourseEnrollmentCriteriaResult> {
  // make api call
  const result = await privateApi.put(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/enrollmentCriteria`,
    params.policy,
  );

  // return the data object
  return result.data;
}

const useUpdateCourseEnrollmentCriteria = createMutation({
  mutationFn: async (variables: UpdateCourseEnrollmentCriteriaParams) => updateCourseEnrollmentCriteria(variables),
});

export { updateCourseEnrollmentCriteria, useUpdateCourseEnrollmentCriteria };
